export default __webpack_public_path__ + "locales/vi/FillPDFDialog.json?hash=aa18648f865c53e0d9b25c8ef6f00457";